var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlankFolder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_ionic-ios-folder-open",
    "data-name": "Icon ionic-ios-folder-open",
    xmlns: "http://www.w3.org/2000/svg",
    width: 75.328,
    height: 64.581,
    viewBox: "0 0 75.328 64.581",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_76371",
    "data-name": "Path 76371",
    d: "M69.081,13.75a3.71,3.71,0,0,0-3.834-3.868H32.569a1.244,1.244,0,0,1-1.026-.4L27.759,5.694l-.034-.034a3.655,3.655,0,0,0-2.91-1.16H8.654A4,4,0,0,0,4.5,8.368V20.645H69.081Z",
    transform: "translate(0.877 -4.5)",
    fill: "#c0c1c7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_76372",
    "data-name": "Path 76372",
    d: "M7.629,13.219h-1.4c-2.153,0-4.255.858-3.952,4.087S6.233,52.741,6.233,52.741c.454,2.994,1.968,4.2,4.2,4.2H69.721c2.136,0,3.532-1.312,3.868-4.2,0,0,3.734-31.1,3.969-34.561.235-3.448-1.5-4.961-3.969-4.961H7.629Z",
    transform: "translate(-2.252 7.636)",
    fill: "#c0c1c7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlankFolder);
export default __webpack_public_path__ + "static/media/blank-folder.96c1f2b5674af85afb4e5304942f0c30.svg";
export { ForwardRef as ReactComponent };